"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SiftErrorPane = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Button = _interopRequireDefault(require("../Button"));

// Fallback view for an entire application error.
var SiftError = function SiftError(_ref) {
  var onRetry = _ref.onRetry;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-full flex flex-col items-center py-32 overflow-auto"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('error-dog.png'),
    alt: t('error.application.title'),
    style: {
      maxWidth: 300
    }
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-4xl text-primary font-semibold mt-5"
  }, t('error.application.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xl font-light"
  }, t('error.application.subtitle[0]')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xl font-light"
  }, t('error.application.subtitle[1]')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, onRetry && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "mx-3 w-64",
    onClick: onRetry
  }, t('error.application.retry'))));
};

var SiftErrorPane = function SiftErrorPane() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-full flex flex-col items-center py-32 overflow-auto"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('error-dog.png'),
    alt: t('error.application.title'),
    style: {
      maxWidth: 200
    }
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-2xl font-semibold mt-5 text-dark"
  }, t('error.application.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-light text-light"
  }, t('error.application.subtitle[0]')));
};

exports.SiftErrorPane = SiftErrorPane;
var _default = SiftError;
exports["default"] = _default;
//# sourceMappingURL=SiftError.js.map